// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","li":"ProCon_li__3uQai","iconCol":"ProCon_iconCol__1rKY8","textCol":"ProCon_textCol__U097t"};